import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/img/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-20115eee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "loader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-cube-grid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube3" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube5" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube6" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube7" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube8" }),
  /*#__PURE__*/_createElementVNode("div", { class: "sk-cube sk-cube9" })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_nav = _resolveComponent("app-nav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "loaded" }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_app_nav),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          name: "router",
          appear: "",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: route.fullPath
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    _createVNode(_component_app_footer)
  ], 64))
}